<template>
  <div>
    <div class="item">
      <nav class="navbar navbar-expand-xl navbar-light dir pony course-header" style="    position: fixed;"
        v-if="routeNames.includes($route.name)" :style="isAuth ? 'background-color: white !important' : ''">
        <div class="container" style="padding:0;">
          <parentHeader v-if="isAuth && $store.state.userType == 'parent'" @pressed="onChange($event)" />
          <teacherHeader v-if="isAuth && $store.state.userType == 'teacher'" @pressed="onChange($event)" />

          <schoolHeader
            v-if="isAuth && $store.state.userType == 'schooladmin' && $store.state.multiple_schools == false"
            @pressed="onChange($event)" />
          <SchoolAdminheader
            v-if="isAuth && $store.state.userType == 'schooladmin' && $store.state.multiple_schools == true"
            @pressed="onChange($event)" />

          <communityHeader v-if="
            isAuth &&
            $store.state.userType == 'student' &&
            ($route.name == 'community' ||
              $route.name == 'communityComments' ||
              $route.name == 'communityProfile' ||
              $route.name == 'friendsView' ||
              $route.name == 'myFriends' ||
              $route.name == 'friendsView')
          " @pressed="onChange($event)" />
          <kidHeader v-else-if="isAuth && $store.state.userType == 'student'" @pressed="onChange($event)" />
          <div v-if="
            windowWidth >= 768 &&
            (!isAuth && !userType.includes($store.state.userType))
          ">
            <img src="../../../static/img/hellocode-v2/hc-w55.svg" width="100%" height="100%" class="logo-prod"
              @click="clicklogo" />
            <!-- <img
              v-else
              src="../../../static/img/hellocode-v2/white-logo.svg"
              width="100%"
              height="100%"
              class="logo-prod"
              alt="hello world kids logo"
               @click="clicklogo"
            >
        -->
          </div>
          <div>
            <img v-if="
              windowWidth <= 767 &&
              (!isAuth && !userType.includes($store.state.userType))
            " src="../../../static/img/hellocode-v2/hc-w55.svg" width="100%" height="100%" class="logo-prod"
              alt="hello world kids logo" @click="clicklogo" />
          </div>

          <!-- <router-link :to="{name:'Home',query:{lang:$route.query.lang}}" class="navbar-brand dir">
          
      
          </router-link>-->

          <span v-if="$route.name == 'schoolBusiness' && windowWidth < 1200" class="school-title-white">{{
            $t("message.main_navbar.forSchools") }}</span>
          <li class="navbar-nav mr-auto" v-if="
            isAuth != null &&
            windowWidth <= 1200 &&
            !userType.includes($store.state.userType)
          ">
            <template v-if="$route.query.lang == 'ar'">
              <Slide left>
                <sideBar @pressed="onChange('en')" />
              </Slide>
            </template>
            <template v-else>
              <Slide right>
                <sideBar @pressed="onChange('ar')" />
              </Slide>
            </template>
          </li>
          <div class="tablet-btns">
            <button v-if="!hideMenuBtnFrom.includes($route.name)" @click="isMenuOpen = !isMenuOpen"
              class="navbar-toggler pull-right" :style="windowWidth <= 1200 && isAuth ? 'display:none' : ''"
              type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent" aria-label="Menu" id="menuBtn">
              {{ $t("message.homepage.menuBtn") }}
              <img v-if="!isMenuOpen" src="../../../static/img/hellocode-v2/greeno-sad-menu.svg" width="21px"
                height="23px" alt="sad-redo" />
              <img v-else src="../../../static/img/hellocode-v2/happy-redo.svg" width="31px" height="23px"
                alt="happy-redo" />
              <span v-if="isMenuOpen" class="material-icons" style="margin: 0;font-size: 19px;">cancel</span>
            </button>
            <button v-if="
              windowWidth >= 768 &&
              windowWidth <= 1200 &&
              !isAuth &&
              $route.name != 'schoolBusiness' &&
              $route.name != 'Login' &&
              $route.name !== 'childRegistration'
            " @click="signIn" class="btn-green">
              {{ $t("message.homepage.signin_button") }}
              <!-- <span v-if="getLang == 'en'" class="material-icons">arrow_forward</span>
              <span v-if="getLang == 'ar'" class="material-icons">arrow_back</span> -->
            </button>
            <button v-if="
              windowWidth >= 768 &&
              windowWidth <= 1200 &&
              !isAuth &&
              $route.name == 'schoolBusiness'
            " @click="showDemoModal()" class="tab-request">
              {{ $t("message.demo.request") }}
            </button>
            <div v-if="windowWidth < 1200 && hideMenuBtnFrom.includes($route.name)">
              <!-- dropdown Lang -->
              <b-dropdown v-if="getLang == 'ar'" id="dropdown-left" left variant="link"
                toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <span :class="$route.name == 'courses'
                    ? 'material-icons lang-drop course-lang'
                    : 'material-icons lang-drop'
                    ">language</span>
                </template>
                <b-dropdown-item>
                  <div class="check-icons" @click="onChange('ar')">
                    <span class="text-drop">{{
                      $t("message.main_navbar.arabic")
                    }}</span>
                    <span v-if="getLang == 'ar'" class="material-icons">done</span>
                  </div>
                </b-dropdown-item>
                <b-dropdown-item>
                  <div class="check-icons" @click="onChange('en')">
                    <span class="text-drop">English</span>
                    <span v-if="getLang == 'en'" class="material-icons">done</span>
                  </div>
                </b-dropdown-item>
              </b-dropdown>
              <b-dropdown v-else id="dropdown-right" right variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <span :class="$route.name == 'courses'
                    ? 'material-icons lang-drop course-lang'
                    : 'material-icons lang-drop'
                    ">language</span>
                </template>
                <b-dropdown-item>
                  <div class="check-icons" @click="onChange('ar')">
                    <span>{{ $t("message.main_navbar.arabic") }}</span>
                    <span v-if="getLang == 'ar'" class="material-icons">done</span>
                  </div>
                </b-dropdown-item>
                <b-dropdown-item>
                  <div class="check-icons" @click="onChange('en')">
                    <span>English</span>
                    <span v-if="getLang == 'en'" class="material-icons">done</span>
                  </div>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div class="collapse navbar-collapse" :class="isMenuOpen ? 'show' : ''" id="navbarSupportedContent">
            <ul :class="windowWidth >= 1200
              ? ' navbar-nav mr-auto'
              : 'container  navbar-nav mr-auto'
              " v-if="isAuth == null && checkRegister()">
              <li v-if="windowWidth <= 1200" class="switch-language">
                <switches v-model="enabled" :value="$route.query.lang"
                  :textEnabled="getLang == 'ar' ? 'English' : 'عربي'"
                  :textDisabled="getLang == 'ar' ? 'عربي' : 'English'" theme="custom" color="blue"></switches>
              </li>
              <li v-if="$route.name == 'schoolBusiness' && windowWidth >= 1200">
                <span :class="base
                  ? 'nav-link  school-title'
                  : 'nav-link  school-title-white'
                  ">{{ $t("message.main_navbar.forSchools") }}</span>
              </li>
              <li :class="windowWidth <= 1200 ? '' : ''" v-if="!hideListItemFrom.includes($route.name)">
                <router-link v-if="$route.name !== 'schoolBusiness'"
                  :to="{ name: 'Home', query: { lang: $route.query.lang } }" :class="homeColor()">
                  {{ $t("message.main_navbar.about_us") }}
                  <span v-if="$route.name == 'Home'" class="material-icons location">location_on</span>
                </router-link>
                <router-link v-else :to="{
                  name: 'schoolBusiness',
                  query: { lang: $route.query.lang },
                }" :class="$route.name == 'schoolBusiness'
                  ? 'nav-link  school-active'
                  : 'nav-link bolder'
                  ">
                  {{ $t("message.main_navbar.about_us") }}
                  <span v-if="$route.name == 'schoolBusiness'" class="material-icons location">location_on</span>
                </router-link>
              </li>
              <li :class="windowWidth <= 1200 ? '' : ''" v-if="!hideListItemFrom.includes($route.name)">
                <!-- <a
                  :class="
                    $route.name == 'courses'
                      ? 'nav-link bolder  course-nav'
                      : 'nav-link bolder'
                  "
                  :href="
                    getLang == 'ar'
                      ? 'http://help.hellocode.me/ar/'
                      : 'http://help.hellocode.me'
                  "
                >
                  {{ $t("message.main_navbar.support") }}
                </a> -->
              </li>
              <li v-if="
                $route.name !== 'schoolBusiness' &&
                !hideListItemFrom.includes($route.name)
              ">
                <router-link :to="{ name: 'courses', query: { lang: $route.query.lang } }" :class="$route.name == 'courses'
                  ? 'nav-link bolder courses-nav course-nav'
                  : 'nav-link bolder'
                  ">
                  {{ $t("message.main_navbar.courses") }}
                  <span v-if="$route.name == 'courses'" class="material-icons location">location_on</span>
                </router-link>
              </li>
              <li v-if="$route.name == 'schoolBusiness'" :class="windowWidth <= 1200 ? '' : ''">
                <router-link :to="{ name: 'Home', query: { lang: $route.query.lang } }" class="nav-link bolder">
                  {{ $t("message.main_navbar.forIndividuals") }}
                  <span v-if="getLang == 'ar'" class="material-icons">north_west</span>
                  <span v-if="getLang == 'en'" class="material-icons">north_east</span>
                </router-link>
              </li>
              <li v-if="
                $route.name !== 'schoolBusiness' &&
                !hideListItemFrom.includes($route.name)
              ">
                <router-link :to="{
                  name: 'schoolBusiness',
                  query: { lang: $route.query.lang },
                }" :class="$route.name == 'courses'
                  ? 'nav-link bolder course-nav'
                  : 'nav-link bolder'
                  ">
                  {{ $t("message.main_navbar.forSchoolsSmall") }}
                  <span v-if="getLang == 'ar'" class="material-icons">north_west</span>
                  <span v-if="getLang == 'en'" class="material-icons">north_east</span>

                  <span v-if="$route.name == 'schoolBusiness'" class="material-icons location">location_on</span>
                </router-link>
              </li>
              <li v-if="
                $route.name !== 'schoolBusiness' &&
                !hideListItemFrom.includes($route.name)
              ">
                <router-link :to="{
                  name: 'examRegistration',
                  query: { lang: $route.query.lang },
                }" :class="$route.name == 'examRegistration'
                  ? 'nav-link bolder course-nav'
                  : 'nav-link bolder'
                  ">
                  {{ $t("message.main_navbar.Certification") }}
                  <span v-if="$route.name == 'Pricing'" class="material-icons location">location_on</span>
                </router-link>
              </li>
              <li v-if="
                $route.name !== 'schoolBusiness' &&
                !hideListItemFrom.includes($route.name)
              ">
                <router-link :to="{ name: 'Pricing', query: { lang: $route.query.lang } }" :class="$route.name == 'Pricing'
                  ? 'nav-link bolder course-nav'
                  : 'nav-link bolder'
                  ">
                  {{ $t("message.main_navbar.pricing") }}
                </router-link>
              </li>
            </ul>

            <ul :class="windowWidth >= 1200
              ? 'navbar-nav ml-auto custom-nav'
              : 'container navbar-nav ml-auto custom-nav'
              " v-if="!isAuth" id="btns-group">
              <li v-if="windowWidth >= 1200" class="m-10  hide-nav">
                <b-dropdown v-if="getLang == 'ar'" id="dropdown-left" left variant="link"
                  toggle-class="text-decoration-none" no-caret>
                  <template slot="button-content">
                    <span :class="$route.name == 'courses'
                      ? 'material-icons lang-drop course-lang'
                      : 'material-icons lang-drop'
                      ">language</span>
                  </template>
                  <b-dropdown-item>
                    <div class="check-icons" @click="onChange('ar')">
                      <span class="text-drop">{{
                        $t("message.main_navbar.arabic")
                      }}</span>
                      <span v-if="getLang == 'ar'" class="material-icons">done</span>
                    </div>
                  </b-dropdown-item>
                  <b-dropdown-item>
                    <div class="check-icons" @click="onChange('en')">
                      <span class="text-drop">English</span>
                      <span v-if="getLang == 'en'" class="material-icons">done</span>
                    </div>
                  </b-dropdown-item>
                </b-dropdown>
                <b-dropdown v-else id="dropdown-right" right variant="link" toggle-class="text-decoration-none"
                  no-caret>
                  <template slot="button-content">
                    <span :class="$route.name == 'courses'
                      ? 'material-icons lang-drop course-lang'
                      : 'material-icons lang-drop'
                      ">language</span>
                  </template>
                  <b-dropdown-item>
                    <div class="check-icons" @click="onChange('ar')">
                      <span>{{ $t("message.main_navbar.arabic") }}</span>
                      <span v-if="getLang == 'ar'" class="material-icons">done</span>
                    </div>
                  </b-dropdown-item>
                  <b-dropdown-item>
                    <div class="check-icons" @click="onChange('en')">
                      <span>English</span>
                      <span v-if="getLang == 'en'" class="material-icons">done</span>
                    </div>
                  </b-dropdown-item>
                </b-dropdown>
              </li>
              <li class="m-10" v-if="
                checkCreateAcount() && !hideListItemFrom.includes($route.name)
              " id="register-list">
                <button @click="unhideModal" class="btn-solid">
                  {{ $t("message.homepage.join_button") }}
                </button>
              </li>
              <li v-if="checkSignIn() && !hideListItemFrom.includes($route.name)" class="m-10" id="login-list">
                <button @click="signIn" class="btn-greens" v-if="$route.name !== 'childRegistration'">
                  {{ $t("message.homepage.signin_button") }}
                  <!-- <span v-if="getLang == 'en'" class="material-icons">arrow_forward</span>
                  <span v-if="getLang == 'ar'" class="material-icons">arrow_back</span> -->
                </button>
              </li>
              <li v-if="$route.name == 'schoolBusiness' && showRequest" class="m-10" id="requestBtn">
                <button @click="showDemo()" class="request pointer">
                  {{ $t("message.demo.request") }}
                </button>
              </li>
            </ul>
            <ul class="navbar-nav ml-auto main-menu" v-else>
              <li class="m-30" v-if="!isAuth && !userType.includes($store.state.userType)">
                <div class="main-nav-language" v-if="$route.query.lang !== 'ar'" @click="onChange('ar')">
                  <span>ع</span>
                </div>
                <div class="main-nav-language" v-else @click="onChange('en')">
                  <span>En</span>
                </div>
              </li>
              <li v-if="
                isAuth != null && !userType.includes($store.state.userType)
              ">
                <template v-if="$route.query.lang == 'ar'">
                  <Slide left>
                    <sideBar @pressed="onChange('en')" />
                  </Slide>
                </template>
                <template v-else>
                  <Slide right>
                    <sideBar @pressed="onChange('ar')" />
                  </Slide>
                </template>
              </li>
              <li id="menu-section" class="pull-left user-image"
                v-if="!isAuth && !userType.includes($store.state.userType)">
                <img src="https://cdn-static-images-frontend.s3-eu-west-1.amazonaws.com/others/default-avatar.svg"
                  alt="User Image" class="img-circle" />
                <!-- <span
                  style="color: #61cfe8"
                >{{$store.getters.getFirstName == null ? truncateText($store.getters.getUserName):truncateText($store.getters.getFirstName)}}</span> -->
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <leaderboard />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Zendesk from "@dansmaculotte/vue-zendesk";
import { eventBus } from "@/main";
import { Slide } from "vue-burger-menu";
import axios from "../../store/axios-auth";
import router from "../../routes";
const comments = () => import("../student/ide/comments.vue");
const points = () => import("./coin.vue");
const leaderboard = () => import("../modals/leaderboard/leaderboardModal.vue");
const sideBar = () => import("./sideBar.vue");
const parentHeader = () => import("./parentHeader.vue"); // header for parent
const kidHeader = () => import("./kidHeader.vue"); // header for kid
const teacherHeader = () => import("./teacherHeader.vue"); // header for teacher
const schoolHeader = () => import("./schoolHeader.vue"); // header for school
const communityHeader = () => import("./communityHeader.vue");
const SchoolAdminheader = () => import("./SchoolAdminheader.vue"); // header for school
import Switches from "vue-switches";
import $ from "jquery";
export default {
  data() {
    return {
      isDropdownOpen: false,
      isMenuOpen: false,
      gmId: process.env.GA_ID,
      langs: ["ar", "en"],
      modalVisible: false,
      showTop: false,
      weekPoint: 0,
      msg: "message.teacher_classrooms.header.tab_title4",
      windowWidth: window.innerWidth,
      base: true,
      enabled: null,
      showRequest: true,
      routeNames: ['admin', 'Login', 'Home', 'Register', 'Resetpassword', 'Studentoverview', 'Lessonprevideo', 'playground-ide', 'verification', 'new-password', 'dashboard', 'story', 'terms', 'privacy', 'homePage', 'manageMyKids', 'payment', 'myorders', 'memberShip', 'renewSubscription', 'teachers', 'classrooms', 'code-assessment', 'classrooms-details', 'classroomsdetails', 'progress-assessment', 'studentQuestions', 'startLearning', 'submissions', 'maze', 'address', 'address2', 'keyboard', 'keyboard2', 'sudoku', 'sudoku2', 'sudoku3', 'coloring', 'coloring2', 'coloring3', 'PaintChallenge1', 'PaintChallenge2', 'PaintChallenge3', 'PaintChallenge4', 'ExcelProject', 'student-profile', 'Studentprofile', 'assessmentResult', 'Ide', 'presentation', 'MicrosoftWordProject', 'Questions', 'studentNotifications', 'allNotificationsDisplay', 'teacher-ide', 'students', 'studentDetails', 'classDetails', 'allStudentDetails', 'Unitygames', 'competition', 'thankyou', 'landing', 'landingGrants', 'profile', 'question', 'curriculum', 'web-ide', 'web-teacher-ide', 'schoolBusiness', 'courses', 'parentRegistration', 'childRegistration', 'Recoverpassword', 'NewPassword', 'EmailSent', 'RecoveryCompleted', 'CodeSent', 'createRegistration', 'EmailConfirme', 'phoneConfirme', 'parentAccountInfo', 'Myworld', 'NewPhonePassword', 'lessonsList', 'playground-ide', 'teacherAccountInfo', 'classroomList', 'teacherMoreDetails', 'schoolInfo', 'reports', 'gamesShared', 'examRegistration', 'registerExam', 'python-ide', 'Newyear', 'Perks', 'python-ide', 'python-teacher-ide', 'school', 'community', 'communityComments', 'communityProfile', 'myFriends', 'friendsView', 'level', 'memoryGame', 'memoryGameStages', 'Pricing', 'puzzleGame', 'Draganddrop'],
      hideMenuBtnFrom: ["Register", "childRegistration", "parentRegistration", "Login", "Recoverpassword", "NewPassword", "EmailSent", "RecoveryCompleted", "CodeSent", "NewPhonePassword"],
      hideListItemFrom: ["Login", "Recoverpassword", "NewPassword", "EmailSent", "RecoveryCompleted", "CodeSent", "NewPhonePassword", "school"],
      userType: ['parent', 'student', 'teacher', 'schooladmin'],

      showRequest: true,
      routeNames: [
        "Login",
        "Home",
        "Register",
        "Resetpassword",
        "Studentoverview",
        "Lessonprevideo",
        "playground-ide",
        "verification",
        "new-password",
        "dashboard",
        "story",
        "terms",
        "privacy",
        "homePage",
        "manageMyKids",
        "payment",
        "myorders",
        "memberShip",
        "renewSubscription",
        "teachers",
        "classrooms",
        "code-assessment",
        "classrooms-details",
        "classroomsdetails",
        "progress-assessment",
        "studentQuestions",
        "startLearning",
        "submissions",
        "maze",
        "address",
        "address2",
        "keyboard",
        "keyboard2",
        "sudoku",
        "sudoku2",
        "sudoku3",
        "coloring",
        "coloring2",
        "coloring3",
        "PaintChallenge1",
        "PaintChallenge2",
        "PaintChallenge3",
        "PaintChallenge4",
        "ExcelProject",
        "student-profile",
        "Studentprofile",
        "assessmentResult",
        "Ide",
        "presentation",
        "MicrosoftWordProject",
        "Questions",
        "studentNotifications",
        "allNotificationsDisplay",
        "teacher-ide",
        "students",
        "studentDetails",
        "classDetails",
        "allStudentDetails",
        "Unitygames",
        "competition",
        "thankyou",
        "landing",
        "landingGrants",
        "profile",
        "question",
        "curriculum",
        "web-ide",
        "web-teacher-ide",
        "schoolBusiness",
        "courses",
        "parentRegistration",
        "childRegistration",
        "Recoverpassword",
        "NewPassword",
        "EmailSent",
        "RecoveryCompleted",
        "CodeSent",
        "createRegistration",
        "EmailConfirme",
        "phoneConfirme",
        "parentAccountInfo",
        "Myworld",
        "NewPhonePassword",
        "lessonsList",
        "playground-ide",
        "teacherAccountInfo",
        "classroomList",
        "teacherMoreDetails",
        "schoolInfo",
        "reports",
        "gamesShared",
        "examRegistration",
        "registerExam",
        "python-ide",
        "Newyear",
        "Perks",
        "python-ide",
        "python-teacher-ide",
        "school",
        "community",
        "communityComments",
        "communityProfile",
        "myFriends",
        "friendsView",
        "Draganddrop",
        "level",
        "memoryGame",
        "memoryGameStages",
        "Pricing",
        "puzzleGame",
        'admin'
      ],
      hideMenuBtnFrom: [
        "Register",
        "childRegistration",
        "parentRegistration",
        "Login",
        "Recoverpassword",
        "NewPassword",
        "EmailSent",
        "RecoveryCompleted",
        "CodeSent",
        "NewPhonePassword",
      ],
      hideListItemFrom: [
        "Login",
        "Recoverpassword",
        "NewPassword",
        "EmailSent",
        "RecoveryCompleted",
        "CodeSent",
        "NewPhonePassword",
        "school",
      ],
      userType: ["parent", "student", "teacher", "schooladmin"],

    };
  },
  computed: {
    isAuth() {
      return this.$store.getters.isAuth;
    },
    getLang() {
      let lang =
        this.$route.query.lang == "ar" || this.$route.query.language == "ar"
          ? "ar"
          : "en";
      this.$i18n.locale = lang;
      return lang;
    },
  },
  components: {
    Slide: Slide,
    points: points,
    comments,
    leaderboard,
    sideBar,
    Switches,
    parentHeader,
    kidHeader,
    teacherHeader,
    schoolHeader,
    communityHeader,
    SchoolAdminheader
  },
  methods: {
    closeModal() {
      this.modalVisible = false;
    },
    unhideModal() {
      router.push({
        name: "Register",
        params: { type: "parent" },
        query: { lang: this.$route.query.lang },
      });
      //this.$ga.event("create", this.gmId, "auto");
      this.$ga.event("registrationForm", "join", "Register");
      // this.modalVisible = true;
    },
    clicklogo() {
      if (this.$route.name !== "schoolBusiness") {
        router.push({
          name: "Home",
          query: { lang: this.$route.query.lang },
        });
      }
    },

    loginin() {
      if (this.$route.name !== "/register/child") {
        router.push({
          name: "childRegistration",
          query: { lang: this.$route.query.lang },
        });
      }
    },
    isHidden(value) {
      this.modalVisible = false;
    },

    loginBackAsParent() {
      let vm = this;
      let parentProfileId = this.$store.getters.getParentProfileId;
      this.$store.dispatch("loginBackAsParent", parentProfileId).then(
        (resp) => { },
        (error) => {
          console.log(error);
        }
      );
    },
    truncateText(text) {
      if (text.length > 20) {
        return text.slice(0, 18) + "...";
      }
      return text;
    },
    signIn() {
      router.push({ path: "/login", query: { lang: this.$route.query.lang } });
    },
    logout() {
      this.$store.dispatch("logout");
    },
    setGm() {
      // ga("create", this.gmId, "auto");
      // this.$ga.event("navigation", "menu", "pricing");
    },
    setGmManage() {
      // ga("create", this.gmId, "auto");
      this.$ga.event("parentportal", "childmanagement");
    },

    onChange(lang) {
      let vm = this;
      router.push({ query: { lang } });
      if (this.$store.getters.isAuth) {
        this.$store.dispatch("changeLanguage", lang).then(
          (resp) => {
            vm.$emit("forceRerender");
            vm.$i18n.locale = lang;
          },
          (error) => {
            console.log(error);
          }
        );
      } else {
        vm.$emit("forceRerender");
      }
    },
    zendesk() {
      if (this.$store.state.token != null) {
        if ((this.$store.state.userType == 'student' && this.$store.state.isSchoolStudent == 0) || (this.$store.state.userType == 'parent')) {
          setTimeout(() => {
            Vue.use(Zendesk, {
              key: "588e37d8-d76c-4f1b-a935-0536b8669f77",
            });
          }, 1300);
        }
      } else {
        setTimeout(() => {
          Vue.use(Zendesk, {
            key: "588e37d8-d76c-4f1b-a935-0536b8669f77",
          });
        }, 1300);
      }
    },
    homeColor(lang) {
      if (this.$route.name == "Home") {
        return "nav-link router-link-exact-active ";
      } else {
        return "nav-link bolder";
      }
    },
    checkRegister() {
      if (this.windowWidth >= 1200) {
        if (
          this.$route.name == "Register" ||
          this.$route.name == "childRegistration" ||
          this.$route.name == "parentRegistration" ||
          this.$route.name == "EmailConfirme" ||
          this.$route.name == "createRegistration" ||
          this.$route.name == "Login" ||
          this.$route.name == "phoneConfirme"
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    showDemo(topSectionA) {
      if (this.isMenuOpen) {
        this.isMenuOpen = false;
        eventBus.$emit("showDemoModal");
      } else {
        let element = this.$refs[topSectionA];
        window.scrollTo(0, 0);
      }
    },
    showDemoModal() {
      this.isMenuOpen = false;
      eventBus.$emit("showDemoModal");
    },
    checkSignIn() {
      if (this.windowWidth >= 1200) {
        if (
          this.$route.name !== "schoolBusiness" &&
          this.$route.name !== "Login" &&
          this.$route.name !== "Register" &&
          this.$route.name !== "Recoverpassword"
        ) {
          return true;
        } else {
          return false;
        }
      } else if (
        (this.windowWidth < 1200 && this.$route.name == "Login") ||
        this.$route.name == "schoolBusiness"
      ) {
        return false;
      } else {
        return true;
      }
    },
    checkCreateAcount() {
      if (
        this.$route.name == "schoolBusiness" ||
        this.$route.name == "childRegistration" ||
        this.$route.name == "parentRegistration" ||
        this.$route.name == "EmailConfirme" ||
        this.$route.name == "createRegistration" ||
        this.$route.name == "Register" ||
        this.$route.name == "Login" ||
        this.$route.name == "Recoverpassword" ||
        this.$route.name == "phoneConfirme"
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    $route(to, from) {
      $("section").css({ opacity: "1" });
      if (this.isMenuOpen) {
        this.isMenuOpen = false;
      }
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        0
      );
    },

    enabled(to, from) {
      setTimeout(() => {
        if (this.getLang == "en") {
          this.onChange("ar");
        } else {
          this.onChange("en");
        }
      }, 500);
    },

    windowWidth(value) {
      this.windowWidth = value;
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    },
  },
  mounted() {
    let vm = this;
    if (vm.$route.name == "courses") {
      vm.base = false;
    }
    this.zendesk();
    eventBus.$on("showLoginModal", () => {
      this.unhideModal();
    });
    eventBus.$on("showPoints", (event) => {
      this.weekPoint = event;
    });
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth >= 1201) {
        this.isMenuOpen = false;
        $("section").css({ opacity: "1" });
      }
    });
    eventBus.$on("forceRerenders", (res) => {
      this.$emit("forceRerender");
    });

    $(document).ready(function () {
      $(window).scroll(function () {
        if (!vm.$store.getters.isAuth) {
          if ($(window).scrollTop() > $(window).height()) {
            if (!vm.isMenuOpen) {
              $(".pony").css({ "animation-duration": ".8s" });
              $(".pony").css({ "animation-name": "fadeInDown" });
              $("#requestBtn").css({ display: "block" });
            }
            if (vm.$route.name == "schoolBusiness" && vm.windowWidth >= 1200) {
              //  $(".hide-nav").css({ display: "none" });
              // $("#navbarSupportedContent").css({ "background-color": "white" });
              vm.showRequest = true;
            }
          } else {
            $(".pony").css({ "animation-duration": ".8s" });
            $(".pony").css({ "animation-name": "" });
            // $(".hide-nav").css({ display: "block" });
            vm.showRequest = false;
          }
        }
      });
      if (
        (vm.$route.name == "Register" ||
          vm.$route.name == "childRegistration" ||
          vm.$route.name == "parentRegistration") &&
        vm.windowWidth <= 767.98
      ) {
        $("#login-list").css({ width: "58%" });
      }
    });
  },
};
</script>
<style scoped>
.btn-green {
  display: none;
}

.course-header {
  background-color: #254178 !important;
}

.course-nav {
  color: white !important;
}

.course-lang {
  color: white !important;
}

.m-30 {
  margin-top: 15px;
  margin-right: 15px;
  margin-left: 15px;
}

.btn-green,
.btn-greens {
  background: #f4c045;
  box-shadow: inset 0px -4px 0px #cda804;
  border-radius: 14px;
  padding: 10px 43px;
  font-size: 18px;
  line-height: 24px;
  border-color: transparent;
  font-weight: bold;
  color: #0b1e41;
  cursor: pointer;
}

.btn-greens,
.btn-solid {
  width: 100%;
}

.btn-solid {
  background: #ffffff;
  border: 2px solid #0b1e41;
  box-sizing: border-box;
  border-radius: 14px;
  padding: 10px 32px;
  font-size: 18px;
  line-height: 24px;
  font-weight: bold;
  color: #0b1e41;
  cursor: pointer;
}

.request {
  padding: 10px 32px;
  background: #ffffff;
  border: 2px solid #0b1e41;
  box-sizing: border-box;
  box-shadow: inset 0px -4px 0px #0b1e41;
  border-radius: 14px;
}

.tab-request {
  padding: 10px 32px;
  color: black;
  box-sizing: border-box;
  box-shadow: inset 0px -4px 0px #0b1e41;
  border-radius: 14px;
  font-weight: bold;
  background: #ffffff;
  border: 2px solid #0b1e41;
  display: none;
}

select {
  margin-top: 3px;
  height: 34px;
  border: 1px solid #1f1545;
  font-size: 14px;
  background: #ffffff;
}

.menu-item-font {
  color: red;
  font-weight: bold;
}

.point {
  padding: 20px 4px;
  color: #deac13;
  font-weight: bold;
  text-align: center;
}

#points {
  padding: 6px 0px;
  color: #deac13;
  font-weight: bold;
  margin-right: -18px;
}

#points span {
  background: url("https://cdn-static-images-frontend.s3-eu-west-1.amazonaws.com/coinKids.png");
  background-repeat: no-repeat;
  background-size: 42px;
  display: inline-block;
  width: 122px;
  height: 58px;
  padding-top: 13px;
  color: #e6a60a;
  background-position-y: center;
  font-size: 20px;
}

.hide-menu-item {
  display: none !important;
}

.display-hr {
  display: none;
}

.tablet-btns {
  display: flex;
}

.location {
  display: none;
}

@media (max-width: 1200px) {
  select.form-control {
    padding: 0;
  }
}

@media (max-width: 992px) {
  .display-hr {
    display: block;
  }

  .padding-style {
    margin-right: 60px;
  }

  .hide-menu-item {
    display: inline-block !important;
  }

  .top-pad {
    padding-top: 18px;
  }

  #points {
    padding: 0px 12px;
  }
}

.opacity {
  opacity: 0.4;
}

select.form-control {
  height: 37px !important;
  font-size: 11px;
  margin-top: 0;
}

.nav-link {
  background-color: transparent;
}

.btn {
  font-size: 1.1rem;
  position: relative;
  padding: 8px;
}

.btn:hover {
  color: rgb(0 31 89) !important;
}

.btn:focus {
  box-shadow: none;
}

@media (max-width: 992px) {
  .btn {
    padding: 8px 0;
  }
}

@media (min-width: 1286px) and (max-width: 1357px) {
  .navbar-light .navbar-nav .nav-link {
    font-size: 16px;
  }

  .btn {
    font-size: 16px;
  }

  .btn-solid {
    font-size: 16px;
  }

  .btn-green,
  .btn-greens {
    font-size: 16px;
  }
}

@media (min-width: 1200px) and (max-width: 1285px) {
  .navbar-light .navbar-nav .nav-link {
    font-size: 16px;
  }

  .btn-solid {
    font-size: 16px;
  }

  .btn-green,
  .btn-greens {
    font-size: 16px;
  }

  .btn {
    font-size: 16px;
  }
}

.language {
  color: #2c3f52;
  border: 3px solid #55c3e0;
  border-radius: 100%;
  width: 50px;
  height: 45px;
  list-style: none;
  display: inline-block;
  float: left;
  margin: -2px;
  padding: 3px;
  font-family: "Font Awesome 5 Brands";
}

.language_en {
  color: #2c3f52;
  border: 3px solid #55c3e0;
  border-radius: 100%;
  width: 50px;
  height: 45px;
  list-style: none;
  display: inline-block;
  float: left;
  margin: -2px;
}

.language:focus {
  outline: none;
}

.language_en:focus {
  outline: none;
}

.item {
  position: -webkit-sticky;
  position: sticky;
  z-index: 999;
  height: 64px;
}

.pony {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  /* width: 95rem; */
  width: 100%;
  top: 0px;
  border: 0px;
  font-weight: 700;
  font-size: 1rem;
  height: 64px;
  padding: 9px;
  background-color: white;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  top: 0px;
  border: 0px;
  font-weight: 700;
  font-size: 1rem;
  height: 64px;
  padding: 9px;
  background-color: white;
}

.back-color {
  background-image: linear-gradient(180deg, #4ac1de 15%, #4ac1de 100%);
  color: white !important;
}

@media (min-width: 1200px) {
  .navbar-light .navbar-nav .nav-link:hover {
    color: #ffffff;
  }

  .navbar-light .navbar-nav .nav-link:focus {
    color: #ffffff !important;
  }

  .router-link-exact-active {
    border-radius: 8px;
    height: auto;
    background: transparent;
    border-bottom: 3px solid #ffffff;
  }

  .courses-nav {
    border-radius: 8px;
    height: auto;
    background: transparent;
    border-bottom: 3px solid #ffffff;
  }

  .navbar-light .navbar-nav .nav-link {
    position: relative;
    margin: 0px 10px;
  }

  .navbar-light .navbar-nav .nav-link:not(.school-title, .router-link-exact-active, .school-title-white):after {
    background: none repeat scroll 0 0 transparent;
    bottom: 0;
    top: 42px;
    content: "";
    display: block;
    height: 4px;
    left: 50%;
    position: absolute;
    background: #ffffff;
    transition: width 0.3s ease 0s, left 0.3s ease 0s;
    width: 0;
  }

  .navbar-light .navbar-nav .nav-link:hover:not(.school-title, .router-link-exact-active, .school-title-white):after {
    width: 100%;
    left: 0;
  }

  .school-active {
    background: transparent;
    border-bottom: 3px solid #ffffff;
  }

  .btn-greens,
  .btn-solid {
    width: 100%;
  }
}

.material-icons {
  font-size: 18px;
  margin: 0px 0px 0px 7px;
  position: relative;
  top: 3px;
}

.lang-drop {
  color: #ffffff;
  font-size: 24px;
}

.check-icons {
  display: flex;
  justify-content: space-between;
  direction: ltr;
}

.dropdown-item.active,
.dropdown-item:active {
  text-decoration: none;
  background-color: transparent;
}

#dropdown-right {
  top: 5px;
}

.fa-bars {
  color: #55c3e0;
  font-size: 35px;
}

#dropdown-1__BV_toggle_ {
  background-color: transparent !important;
  border: none !important;
  color: #69d0e8 !important;
  font-weight: bold !important;
  margin: -3px !important;
}

.text-drop {
  font-size: 16px;
  line-height: 24px;

  letter-spacing: 0.5px;

  color: rgba(0, 0, 0, 0.9);
  font-weight: bold;
}

.school-title {
  color: white !important;
  margin-left: -15px !important;
  margin: auto;
}

.school-title-white {
  color: white !important;
  margin-left: -5px !important;
  margin: auto;
}

@media (min-width: 320px) and (max-width: 480px) {
  .nav-link {
    border-bottom: 1px solid #dbdfe8 !important;
  }

  .navbar-nav li:last-child .nav-link {
    border-bottom: 0px solid #dbdfe8 !important;
  }

  .school-title {
    margin-left: 0px !important;
  }
}

@media (min-width: 1200px) {
  .mobile {
    display: none;
  }
}

.m-40 {
  margin-top: 20px;
  margin-right: 15px;
  margin-left: 15px;
}

.fa-calendar-alt {
  font-size: 1.5rem;
  color: #e5a70c;
}

#week {
  padding: 6px 0px;
  color: #f4bb47;
  font-size: 1.3rem;
  font-weight: bold;
}

.fa-calendar-alt:before {
  margin: 10px;
}

.main-nav-language {
  border: 2px dotted #2d4776;
  border-radius: 44%;
  padding: 4px 16px;
  font-weight: 700;
  display: inline-block;
}

.main-nav-language:hover {
  cursor: pointer;
}

#requestBtn {
  display: none;
}

@media (min-width: 768px) and (max-width: 1199.98px) {
  .navbar-toggler {
    background: #dce4f3;
    box-shadow: inset 0px -4px 0px rgb(49 87 160 / 15%);
    border-radius: 14px;
    padding: 11px 13px;
    margin: 0px 16px;
    color: #3157a0;
    font-weight: bold;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
  }

  .router-link-exact-active {
    background-color: transparent;
  }

  .nav-link {
    border-bottom: 1px solid #50699b !important;
  }

  .navbar-light .navbar-nav .nav-link {
    line-height: 61px;
  }

  .btn-solid {
    margin: 24px 0px;
    width: 100%;
  }

  .switch-language {
    text-align: right;
  }

  .location {
    display: none;
  }

  .school-title {
    margin-left: 0px !important;
  }

  .request {
    padding: 10px 32px;
    box-sizing: border-box;
    border-radius: 14px;
    border: none;
    background: #36d3fa;
    box-shadow: inset 0px -4px 1px #00a1c9;
    font-weight: bold;
    width: 100%;
  }

  #btns-group {
    display: flex;
    flex-direction: row !important;
    justify-content: center;
    align-items: center;
  }

  #btns-group>#register-list,
  #btns-group>#login-list,
  #requestBtn {
    width: 50%;
  }
}

@media (min-width: 320px) and (max-width: 767.88px) {
  .navbar-toggler {
    background: #dce4f3;
    box-shadow: inset 0px -4px 0px rgb(49 87 160 / 15%);
    border-radius: 14px;
    padding: 10px 30px;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: #3157a0;
  }

  .btn-green {
    display: none;
  }

  .router-link-exact-active {
    background-color: transparent;
  }

  .switch-language {
    text-align: right;
  }

  .navbar-light .navbar-nav .nav-link {
    line-height: 53px;
    padding: 5px;
  }

  .btn-greens,
  .btn-solid {
    width: 100%;
  }

  #navbarSupportedContent .custom-nav {
    flex-direction: column-reverse;
    margin-top: 24px;
  }

  .logo-prod {
    width: 55px;
    margin-left: 10px;
  }

  .location {
    margin: 4%;
    float: right;
    font-size: 20px;
    top: 0;
    display: block;
    font-weight: bold;
    font-size: 18px;
    color: white;
  }

  .request {
    padding: 10px 32px;
    background: #36d3fa;
    box-sizing: border-box;
    box-shadow: inset 0px -4px 0px #0b1e41;
    border-radius: 14px;
    border: none;
    background: #36d3fa;
    box-shadow: inset 0px -4px 1px #00a1c9;
    font-weight: bold;
    width: 100%;
  }

  #btns-group {
    display: flex;
    flex-direction: row !important;
    justify-content: center;
    align-items: center;
  }

  #btns-group>#register-list,
  #btns-group>#login-list,
  #requestBtn {
    width: 50%;
  }
}

@media screen and (min-width: 320px) and (max-width: 767px) {

  #requestBtn .request,
  #login-list .btn-greens {
    padding: 12px 15px;
  }
}

@media screen and (max-width: 359.98px) {

  #requestBtn .request,
  #login-list .btn-greens {
    padding: 12px 10px;
  }
}

@media screen and (max-width: 375.98px) {
  .navbar-toggler {
    padding: 10px 18px;
  }
}

@media screen and (max-width: 340px) {
  .navbar-toggler {
    padding: 10px 15px;
  }

  #requestBtn .request {
    padding: 13px 6px;
    font-size: 15px;
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -20%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/header.vue